"use client";
import { useState } from "react";
import NewsCard, { NewsCardGroup } from "../../theme/components/NewsCard";
import { toCockpitImagePath } from "./CockpitImage";
import LoadMoreButton from "../../common/components/LoadMoreButton";
import { useTranslations } from "next-intl";

const NewsList = ({ newses, rootRoute = null, limit = 15 }) => {
  const [offset, setVisibleCount] = useState(limit);
  const t = useTranslations();
  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + limit);
  };
  const hasMore = offset < newses.length;
  const paginatedNews = newses.slice(0, offset);

  return (
    <>
      <NewsCardGroup>
        {paginatedNews?.map(({ _id, title, cover, topic }) => (
          <NewsCard
            key={_id}
            href={rootRoute ? `${rootRoute}/${_id}` : null}
            label={topic}
            imagePath={toCockpitImagePath(cover?.path)}
            title={title}
            mode="static"
          />
        ))}
        {!paginatedNews?.length && (
          <div className="p-3 py-4">{t("no_result")}</div>
        )}
      </NewsCardGroup>
      <div className="text-center">
        <LoadMoreButton onLoadMore={handleLoadMore} visible={hasMore} />
      </div>
    </>
  );
};

export default NewsList;
